import moment from 'moment';
import 'moment/locale/id';
import InputNumber from 'rc-input-number';
import 'rc-input-number/assets/index.css';
import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import { Card, Col, Input, InputGroup, Row } from 'reactstrap';
import { ResponsiveContainer } from 'recharts';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isNone, isFunction } from 'iotera-base/object';
import blank from '../../../icons/blank.PNG';
import Textfit from '../../../react/react-textfit/lib/Textfit';


// For Unique Id
const uuidv1 = require('uuid/v1');

export class SimpleButtonCard extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        let id = safeDeepGetWithType(this, ['props', 'id'], uuidv1());
        let on_click = safeDeepGetWithType(this, ['props', 'on_click']);
        if (isFunction(on_click)) {
            on_click({ id });
        }
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        if (title === '') {
            title = "Tombol perintah"
        }
        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Kirim"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }
        return (
            <Card>
                <Row style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop: '10px' }}>
                    <div  >
                        <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize' }}>
                            <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                        </Textfit>
                    </div>
                </Row>

                <ResponsiveContainer height={75} >
                    <div className='centeringItem'>
                        <div style={{ marginBottom: '10px' }}>
                            <button type="submit" className="button-iotera button-iotera-green" onClick={this.handleClick}>
                                <Textfit mode="single" max={12} >
                                    {button_label}
                                </Textfit>
                            </button>
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#939598', textAlign: 'center', marginTop: 10 }}>
                                {status}
                            </Textfit>
                        </div>
                    </div>
                </ResponsiveContainer>
            </Card>

        );
    }
}

export class ButtonInputCardNumber extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(input) {
        let id = safeDeepGetWithType(this, ['props', 'id'], uuidv1());
        let on_click = safeDeepGet(this, ['props', 'on_click']);
        if (!isNone(input.state.value)) {
            if (isFunction(on_click)) {
                on_click( id, input.state.value );
            }
        }
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        let min = safeDeepGetWithType(this, ['props', 'min'], 0);
        let max = safeDeepGetWithType(this, ['props', 'max'], 100);
        let default_value = safeDeepGet(this, ['props', 'default_value'], '');
        if (title === '') {
            title = "Kirim perintah"
        }
        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Send"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }

        return (
            <div>
                <Card >
                    <Row style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop: '10px' }}>
                        <div>
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize' }}>
                                <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                            </Textfit>
                        </div>
                    </Row>

                    <ResponsiveContainer height={75} >
                        <div className='centeringItem'>
                            <div style={{ marginBottom: '10px' }}>
                                <Row style={{ marginLeft: 10, marginRight: 10 }}>
                                    <Col style={{ padding: 0, margin: 0, marginRight: 5 }}>

                                        <InputNumber
                                            min={min}
                                            max={max}
                                            defaultValue={default_value}
                                            placeholder={default_value}
                                            ref={(input) => this.input = input}
                                            style={{ height: "36px" }}
                                        />
                                    </Col>
                                    <Col style={{ padding: 0, margin: 0, marginLeft: 5 }}>
                                        <button type="submit" className="button-iotera button-iotera-green" style={{ height: 36, minWidth: '100%' }} onClick={(e) => this.handleClick(this.input)} >
                                            <Textfit mode="single" max={12} >
                                                {button_label}
                                            </Textfit>
                                        </button>
                                    </Col>
                                </Row>
                                <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#939598', textAlign: 'center', marginTop: 10 }}>
                                    {status}
                                </Textfit>
                            </div>
                        </div>
                    </ResponsiveContainer>
                </Card>

            </div>
        );
    }
}

export class ButtonInputCardText extends Component {
    constructor(props) {
        super(props);
        let min = safeDeepGet(props, ['min'], 0);
        let max = safeDeepGet(props, ['max'], "30");
        let default_value = safeDeepGet(props, ['default_value'], '');

        this.state = { value: default_value, max: max, min: min };

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    handleClick(input) {
        let id = safeDeepGetWithType(this, ['props', 'id'], uuidv1());
        let on_click = safeDeepGetWithType(this, ['props', 'on_click']);
        if (!isNone(input)) {
            if (isFunction(on_click)) {
                on_click( id, input );
            }
        }
    }

    render() {
        let default_value = safeDeepGet(this, ['props', 'default_value'], '');
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        if (title === '') {
            title = "Kirim perintah"
        }
        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Kirim"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }

        let col = safeDeepGetWithType(this, ['props', 'w'], 0);
        if (col === 2) {
            col = 6
        } else if (col === 4) {
            col = 12
        } else {
            col = 3
        }

        return (
            <div>
                <Card >
                    <Row style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop: '10px' }}>
                        <div>
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize' }}>
                                <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                            </Textfit>
                        </div>
                    </Row>

                    <ResponsiveContainer height={75} >
                        <div className='centeringItem'>
                            <div style={{ marginBottom: '10px' }}>
                                <Row style={{ marginLeft: 10, marginRight: 10 }}>
                                    <Col style={{ padding: 0, margin: 0, marginRight: 5 }}>

                                        <Input
                                            maxLength={this.state.max}
                                            type="text"
                                            placeholder={default_value}
                                            ref={(input) => this.input = input}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                    <Col style={{ padding: 0, margin: 0, marginLeft: 5 }}>
                                        <button type="submit" className="button-iotera button-iotera-green" style={{ height: 36, minHeight: '100%' }} onClick={(e) => this.handleClick(this.state.value)} >
                                            <Textfit mode="single" max={12} >
                                                {button_label}
                                            </Textfit>
                                        </button>
                                    </Col>
                                </Row>

                                <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#939598', textAlign: 'center', marginTop: 10 }}>
                                    {status}
                                </Textfit>
                            </div>

                        </div>
                    </ResponsiveContainer>
                </Card>
            </div>
        );
    }
}

export class ButtonInputCardToggle extends Component {
    constructor(props) {
        super(props);

        let default_value = safeDeepGetWithType(props, ['default_value'], false);
        this.state = { value: default_value };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        let id = safeDeepGetWithType(this, ['props', 'id'], uuidv1());
        let on_click = safeDeepGetWithType(this, ['props', 'on_click']);
        let currentValue = !this.state.value;
        if (!isNone(currentValue)) {
            if (isFunction(on_click)) {
                on_click( id,  currentValue );
            }
        }
        this.setState({ value: currentValue });
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        if (title === '') {
            title = "Kirim perintah"
        }
        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Kirim"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }

        return (
            <div>
                <Card >
                    <Row style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop: '10px' }}>
                        <div>
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize' }}>
                                <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                            </Textfit>
                        </div>
                    </Row>

                    <ResponsiveContainer height={75} >
                        <div className='centeringItem'>
                            <div style={{ marginBottom: '10px' }}>
                                <Col>
                                    <InputGroup style={{ marginTop: 5, marginBottom: 18 }}>
                                        <Toggle icons={false} checked={this.state.value}
                                            onChange={this.handleChange}
                                            ref={(toggle) => this.toggle = toggle}
                                        />
                                    </InputGroup>
                                </Col>
                                <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#939598', textAlign: 'center', marginTop: 10 }}>
                                    {status}
                                </Textfit>
                            </div>
                        </div>
                    </ResponsiveContainer>
                </Card>
            </div>
        );
    }
}

export class ButtonInputCardDate extends Component {
    constructor(props) {
        super(props);
        moment.locale('id');
        this.state = {
            date: moment(),
            moment: moment(),
            focused: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }


    handleChange = (date) => {
        this.setState({
            date
        });
    }

    handleClick = (input) => () => {
        let id = safeDeepGetWithType(this, ['props', 'id'], uuidv1());
        let on_click = safeDeepGetWithType(this, ['props', 'on_click']);
        let date = moment(input).format("DD-MM-YYYY HH:mm:ss");
        if (!isNone(date)) {
            if (isFunction(on_click)) {
                on_click( id,  date );
            }
        }
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        if (title === '') {
            title = "Kirim perintah"
        }

        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Kirim"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }

        let dateFormat = safeDeepGet(this, ['props', 'date_format'], true);
        if (dateFormat) {
            dateFormat = "DD MMM YYYY"
        }
        let timeFormat = safeDeepGet(this, ['props', 'time_format'], true);
        let locale = safeDeepGet(this, ['props', 'locale'], "id-ID");

        let yesterday = Datetime.moment().subtract(1, 'day');
        let valid = function (current) {
            return current.isAfter(yesterday);
        };

        return (
            <div>
                <div className="card-iotera" style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <Row style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '12px', paddingTop: '10px' }}>
                        <div>
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize' }}>
                                <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                            </Textfit>
                        </div>
                    </Row>

                    <ResponsiveContainer height={75} >
                        <div className='centeringItem'>
                            <div style={{ paddingBottom: '10px' }}>
                                <Row style={{ marginLeft: 10, marginRight: 10 }}>
                                    <Col style={{ padding: 0, margin: 0, marginRight: 5 }}>
                                        <Datetime
                                            value={this.state.date}
                                            onChange={this.handleChange}
                                            locale={locale}
                                            isValidDate={valid}
                                            closeOnSelect={true}
                                            dateFormat={dateFormat}
                                            timeFormat={timeFormat} />
                                    </Col>
                                    <Col style={{ padding: 0, margin: 0, marginLeft: 5 }}>
                                        <button type="submit" className="button-iotera button-iotera-green" style={{ height: 36, minHeight: '100%' }} onClick={this.handleClick(this.state.date)} >
                                            <Textfit mode="single" max={12} >
                                                {button_label}
                                            </Textfit>
                                        </button>
                                    </Col>
                                </Row>
                                <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#939598', textAlign: 'center', marginTop: 10 }}>
                                    {status}
                                </Textfit>
                            </div>
                        </div>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    }
}

export class ButtonInputCardDateRange extends Component {
    constructor(props) {
        super(props);
        moment.locale('id');
        let m = moment();
        this.state = {
            startDate: m,
            endDate: m.add(2, 'days'),
            moment: m,
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        let id = safeDeepGetWithType(this, ['props', 'id'], uuidv1());
        let on_click = safeDeepGetWithType(this, ['props', 'on_click']);
        let startDate = moment(this.state.startDate).format("DD-MM-YYYY HH:mm:ss");
        let endDate = moment(this.state.endDate).format("DD-MM-YYYY HH:mm:ss");
        if (!isNone(startDate) && !isNone(endDate)) {
            if (isFunction(on_click)) {
                on_click( id,  startDate, endDate );
            }
        }
    }

    render() {
        let title = safeDeepGetWithType(this, ['props', 'title'], '');
        if (title === '') {
            title = "Kirim perintah"
        }

        let button_label = safeDeepGetWithType(this, ['props', 'button_label'], '');
        if (button_label === '') {
            button_label = "Kirim"
        }
        let status = safeDeepGetWithType(this, ['props', 'status'], '');
        let pict = safeDeepGetWithType(this, ['props', 'pict'], '');
        if (pict === '') {
            pict = blank;
        }

        let start = this.state.startDate;
        let end = this.state.endDate;
        return (
            <div>
                <div className="card-iotera" style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <Row style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '10px', paddingBottom: 12 }}>
                        <div>
                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize' }}>
                                <img src={pict} alt='icon' style={{ height: '26px', marginRight: 5 }} />{title}
                            </Textfit>
                        </div>
                    </Row>

                    <ResponsiveContainer height={75} >
                        <div className='centeringItem'>
                            <div style={{ paddingBottom: '10px' }}>

                                <Row style={{ marginLeft: 10, marginRight: 10 }}>
                                    <div className='col-sm-10' style={{ padding: 0, margin: 0 }}>
                                        <DateRangePicker
                                            startDate={start} // momentPropTypes.momentObj or null,
                                            startDateId="start" // PropTypes.string.isRequired,
                                            endDate={end} // momentPropTypes.momentObj or null,
                                            endDateId="end" // PropTypes.string.isRequired,
                                            withPortal={true}
                                            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                            small={true}
                                        />
                                    </div>
                                    <div className='col-sm-2' style={{ padding: 0, margin: 0 }}>
                                        <button type="submit" className="button-iotera button-iotera-green" style={{ height: 36, minHeight: '100%' }} onClick={this.handleClick} >
                                            <Textfit mode="single" max={12} >
                                                {button_label}
                                            </Textfit>
                                        </button>
                                    </div>
                                </Row>

                                <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#939598', textAlign: 'center', marginTop: 10 }}>
                                    {status}
                                </Textfit>
                            </div>
                        </div>
                    </ResponsiveContainer>
                </div>
            </div>
        );
    }
}